/* import __COLOCATED_TEMPLATE__ from './reviewable-created-by-name.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
